import API, {source} from "../utils/api";
import axios from 'axios';

let getReportSource = null;

export const getXeroInvoiceSettingApi = async (data) => {
    const response = await API.get('report/xero-invoices/settings', {
        params: data,
    });
    return { response };
};

export const getReportXeroInvoicesApi = async (text) => {
    if (getReportSource) {
        getReportSource.cancel('Canceled due to new request');
    }
    getReportSource = axios.CancelToken.source();
    const response = await API.get('report/xero-invoices', {
        params: text,
        cancelToken: getReportSource.token,
    });
    return { response };
};

export const exportInvoicesApi = async (data) => {
    const response = await API.get('report/xero-invoices/export', {
        params: data,
    });
    return { response };
};

export const exportInvoiceItemsApi = async (data) => {
    const response = await API.get('report/xero-invoices/items/export', {
        params: data,
    });
    return { response };
};